// extracted by mini-css-extract-plugin
export default {"container":"Toggle_container__m-OmJ","inner":"Toggle_inner__bBnhD","circle":"Toggle_circle__K5WaO"};